import Vue from 'vue'
import Lambda from "@/components/Lambda.vue";
import ServiceSelector from "@/components/ServiceSelector.vue";
import ApiGateway from "@/components/ApiGateway.vue";
import Sqs from "@/components/Sqs.vue";
import ExternalApi from "@/components/ExternalApi.vue";
import EventBridge from "@/components/EventBridge.vue";
import ScenarioInput from "@/components/ScenarioInput.vue";
import Connector from "@/components/Connector.vue";
import Simulator from "@/components/Simulator.vue";
import axios, {AxiosStatic} from "axios";

// Import the assets
import './assets/tailwind.css'

Vue.config.productionTip = false;

Vue.component('simulator', Simulator);
Vue.component('connector', Connector);
Vue.component('scenario-input', ScenarioInput);
Vue.component('service-selector', ServiceSelector);
Vue.component('lambda', Lambda);
Vue.component('api-gateway', ApiGateway);
Vue.component('sqs', Sqs);
Vue.component('event-bridge', EventBridge);
Vue.component('external-api', ExternalApi);

Vue.use({
    install() {
        Vue.prototype.axios = axios.create();
    },
});

declare module 'vue/types/vue' {
    interface Vue {
        axios: AxiosStatic;
    }
}
